import PricePlanColumns from 'modules/profile/user-plan/components/price-plan-columns'
import PricePlanFeaturesColumn from 'modules/profile/user-plan/components/price-plan-features-column'
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum'
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface'
import getBillingPeriodFromSubscriptionPeriod from 'modules/profile/user-plan/utils/price-plan-utils'
import React, { useEffect, useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { dateTimeFormat } from 'shared/utils/date-time-format'

export interface UserPlanTableProps {
  currentUserPlanData: UseUserPlanInterface
  showWithTax: boolean
}

const UserPlanTable = ({ currentUserPlanData, showWithTax }: UserPlanTableProps) => {
  const [billingPeriod, setBillingPeriod] = useState<BillingPeriodEnum>(
    getBillingPeriodFromSubscriptionPeriod(currentUserPlanData.subscriptionPeriod) ||
      BillingPeriodEnum.monthly,
  )
  const { user } = useUser()
  const { t } = useLocoTranslation()

  useEffect(() => {
    if (currentUserPlanData.subscriptionPeriod) {
      setBillingPeriod(
        getBillingPeriodFromSubscriptionPeriod(currentUserPlanData.subscriptionPeriod) ||
          BillingPeriodEnum.monthly,
      )
    }
  }, [currentUserPlanData])

  return (
    <div className="bg-background-secondary w-full overflow-hidden rounded-md">
      {currentUserPlanData.nextBillingDate && user && (
        <div className="text-text-primary font-inter py-3 pl-4 text-lg">
          <div className="[&>svg]:fill-brand-primary [&>svg]:main-transition-colors flex items-center gap-1.5">
            {t('dashboard.settings.user_plan.next_billing_title')}
            <b className="text-text-primary font-inter">
              {dateTimeFormat(currentUserPlanData.nextBillingDate, {
                timeFormat: user?.timeFormat,
                dateFormat: user?.dateFormat,
                timeZone: user?.timezone,
              })}
            </b>
          </div>
        </div>
      )}
      <div className="flex flex-1 flex-row justify-items-center lg:grid lg:w-full lg:grid-cols-[20%_80%]">
        <PricePlanFeaturesColumn
          billingPeriod={billingPeriod}
          setBillingPeriod={setBillingPeriod}
          data={currentUserPlanData}
        />
        <PricePlanColumns
          currentUserPlanData={currentUserPlanData}
          billingPeriod={billingPeriod}
          showWithTax={showWithTax}
        />
      </div>
    </div>
  )
}

export default UserPlanTable
